export default "__VITE_ASSET__0l8eNfKO__"